import axios from "../interceptors";

const AppService = {};

AppService.facebookInstall = async (data, token) =>
  axios.put("app/facebook/install", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
AppService.googleInstall = async (data, token) =>
  axios.put(`app/google/install`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
AppService.quickbooksInstall = async (data, token) =>
  axios.put(`app/quickbooks/install`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
AppService.createSubscription = async (data) =>
  axios.post("app/shopify/subscriptions", data);

AppService.getQuickbooksAccounts = async ({ token, merchantId }) => {
  const url = `quickbooks/accounts?merchantId=${merchantId}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

AppService.updateQuickbooksAccounts = async (data, token) => {
  return axios.put("quickbooks/accounts", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

AppService.quickbooksDisconnect = async (data, token) => {
  return axios.delete("app/quickbooks/disconnect", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export default AppService;
